import { CircuitBreaker } from './circuitBreaker.mjs';

const store = new Map();
function getCircuitBreaker(hash, settings) {
    if (store.has(hash)) {
        const circuitBreaker = store.get(hash);
        circuitBreaker.setConfig(settings);
        return circuitBreaker;
    }
    const circuitBreaker = new CircuitBreaker(settings);
    store.set(hash, circuitBreaker);
    return circuitBreaker;
}
function getCircuitBreakerSize() {
    return store.size;
}
function getHashes() {
    return Array.from(store.keys());
}

export { getCircuitBreaker, getCircuitBreakerSize, getHashes };
//# sourceMappingURL=circuitBreakersStore.mjs.map
